import React, { useState } from 'react';
import { PopupModal } from '../../../Modals/Index';
import { LabeledInput } from '../../../Components';
import './index.css';
const Index = ({ email, state, setStateFalse, onConfirmHandler }) => {
    const [password, setpassword] = useState('');
    const onClickHandler = (e) => {
        e.preventDefault();
        onConfirmHandler();
    };
    return (
        <PopupModal setStateFalse={setStateFalse} state={state}>
            <div style={{ width: 'max-content' }} className="popupConatiner">
                <div className="home_head flex-start">
                    <div className="home_head">
                        <div>
                            <h2 className="home_heading">Confirm Your Password</h2>
                        </div>
                    </div>
                </div>
                <form className="password-popup" action={`submit`}>
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        name="Password"
                        type="password"
                        value={password}
                        changeHandler={(e) => {
                            setpassword(e.target.value);
                        }}
                        label={'Password'}
                    />
                    <div className="password-popup_footer">
                        <button
                            type="reset"
                            onClick={setStateFalse}
                            className="btn-gray"
                            style={{ marginRight: '1rem' }}
                        >
                            <p>Close</p>
                        </button>
                        <button onClick={onClickHandler} type="submit" className="btn-orange">
                            <p>Confirm</p>
                        </button>
                    </div>
                </form>
            </div>
        </PopupModal>
    );
};

export default Index;
